
import { ConfiguracoesProjeto, ParametrosService } from "../../../shared";
import { GerenciadorCookieSvaut } from "../../../shared/svaut/gerenciador-cookie-svaut";

export class StorageManagementPortal {

 public configuracao: ConfiguracoesProjeto;

    constructor(private readonly parametrosService: ParametrosService) { }

    public Logout() {
     
        localStorage.removeItem('consumidor');
        localStorage.removeItem('authorizationData');
        sessionStorage.removeItem('editMode');
        sessionStorage.removeItem('tokenAcesso');
        sessionStorage.removeItem('ano_sorteio_mensal_atual');
        sessionStorage.removeItem('mes_sorteio_mensal_atual');
    
        // indica login via gov br
        if(localStorage.getItem('login_via_gov_br') == "1") {

            localStorage.removeItem('login_via_gov_br');

            this.LogoutUsuarioGovBrParaTelaInicial();

        } else {
            // Limpa todos os demais localstorage previamente armazenados, caso houver!
            localStorage.clear();
        }

        
    }
    
    public LogoutUsuarioGovBrParaTelaInicial() {

         GerenciadorCookieSvaut.LimparCookieRedirecionamento();
         GerenciadorCookieSvaut.DefinirCookieRedirecionamento(this.urlInicioPortal);

         this.RealizarRedirecionamentoLogoutSvaut();
    }

    public RealizarRedirecionamentoLogoutSvaut() {

        // --- REDIRECIONA PARA O LOGOUT DO GOV.BR ---
          window.location.href = this.urlLogoutGovBr;
    }

    public get urlInicioPortal() {
        this.configuracao = this.parametrosService.getConfiguracao();
        return this.configuracao.url_inicio_portal_frontend;     
    }

     public get urlLogoutGovBr () {
        this.configuracao = this.parametrosService.getConfiguracao();
        return this.configuracao.url_logout_gov_br;     
    }
}






// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/storage-management-portal.ts